import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {BackgroundTask} from './background-task.model';

@Injectable({providedIn: 'root'})
export class BackgroundTaskService {
  constructor(private http: HttpClient) {}

  getTasks(limit: number = 10): Observable<BackgroundTask[]> {
    return this.http.get<BackgroundTask[]>(`${environment.rootUrl}/background-task?limit=${limit}`);
  }

  getPendingTasks(): Observable<BackgroundTask[]> {
    return this.http.get<BackgroundTask[]>(`${environment.rootUrl}/background-task/pending`);
  }

  getTask(id: number): Observable<BackgroundTask> {
    return this.http.get<BackgroundTask>(`${environment.rootUrl}/background-task/${id}`);
  }
}
